import { useRouteMatch } from "react-router";

import {
    PHOTO_PATH,
    SEARCH,
    PHOTO_DETAIL,
    BROWSE_BY_TAG,
    BROWSE_BY_SHOOT_ID,
    BROWSE_BY_CREATOR_USERNAME,
    BROWSE_SIMILAR_BY_PHOTO_ID,
    BROWSE_BY_CAMPAIGN,
    iconsSearchPath,
    iconsCollectionSearchPath,
    photosLandingPath
} from "data/links";
import {
    heroSearchPlaceholderIcons,
    heroSearchPlaceholderPhotos
} from "./data";

import { desktopHeaderHeight } from "./constants";
import breakpoints from "core/breakpoints";
import colors from "core/colors";

const marginForSearchContainer = desktopHeaderHeight / 2;
const marginTopSearchContainerRemToPx = 27;
const negativeSearchContainerMargin = -(
    marginForSearchContainer - marginTopSearchContainerRemToPx
);

export const animateScrollingDown = ({
    navRef,
    searchContainerRef,
    navLinkRef,
    heroSearchBgColor,
    siteHeaderRef
}) => {
    if (navRef && navRef.current) {
        navRef.current.style.opacity = "0";
        searchContainerRef.current.style.marginTop = `${negativeSearchContainerMargin}px`;
        navLinkRef.current.setAttribute("aria-hidden", "true");
        heroSearchBgColor &&
            (siteHeaderRef.current.style.background = colors.snow);
        siteHeaderRef.current &&
            siteHeaderRef.current.classList.add("scrolledDown");
        siteHeaderRef.current &&
            siteHeaderRef.current.classList.remove("scrolledUp");
    }
};

export const animateScrollingBackUp = ({
    navRef,
    searchContainerRef,
    navLinkRef,
    heroSearchBgColor,
    siteHeaderRef
}) => {
    if (navRef && navRef.current) {
        navRef.current.style.opacity = "1";
        searchContainerRef.current.style.marginTop = "0";
        navLinkRef.current.setAttribute("aria-hidden", "false");
        heroSearchBgColor &&
            (siteHeaderRef.current.style.background = heroSearchBgColor);
        siteHeaderRef.current &&
            siteHeaderRef.current.classList.remove("scrolledDown");
        siteHeaderRef.current &&
            siteHeaderRef.current.classList.add("scrolledUp");
    }
};

// helpers for animations:
import {
    scrollToDesktopWithHero,
    scrollToTabletWithHero,
    scrollToMobileWithHero,
    scrollToDesktopNoHero,
    scrollToDesktopHeroSearchBar,
    scrollToTabletHeroSearchBar,
    scrollToMobileHeroSearchBar,
    scrollToDesktopWithHeroLanding,
    scrollToTabletWithHeroLanding,
    scrollToMobileWithHeroLanding,
    scrollToDesktopHeroLandingSearchBar,
    scrollToTabletHeroLandingSearchBar,
    scrollToMobileHeroLandingSearchBar
} from "./constants";

const tabletBreakpoint = breakpoints.beforeTabletPx;
const desktopBreakpoint = breakpoints.beforeDesktopPx;

export const scrollPosAnimation = ({ browserWidth, isHeroSearchV2 }) => {
    const isLandingPage = window.location.pathname === photosLandingPath;

    let animateHeaderScrollPos;

    if (isLandingPage) {
        if (browserWidth > desktopBreakpoint) {
            // desktop scroll position:
            animateHeaderScrollPos = scrollToDesktopWithHeroLanding;
        } else if (browserWidth > tabletBreakpoint) {
            // tablet scroll position:
            animateHeaderScrollPos = scrollToTabletWithHeroLanding;
        } else {
            // mobile scroll position:
            animateHeaderScrollPos = scrollToMobileWithHeroLanding;
        }
    } else {
        if (browserWidth > desktopBreakpoint) {
            // desktop scroll position:
            animateHeaderScrollPos = scrollToDesktopWithHero;
        } else if (browserWidth > tabletBreakpoint) {
            // tablet scroll position:
            animateHeaderScrollPos = scrollToTabletWithHero;
        } else {
            // mobile scroll position:
            animateHeaderScrollPos = scrollToMobileWithHero;
        }
    }

    return isHeroSearchV2 ? animateHeaderScrollPos : scrollToDesktopNoHero;
};

export const scrollPosShowHideSearch = ({ browserWidth, isHeroSearchV2 }) => {
    const isLandingPage = window.location.pathname === photosLandingPath;
    let showHideHeroScrollPos;

    if (isLandingPage) {
        if (browserWidth > desktopBreakpoint) {
            // desktop scroll position:
            showHideHeroScrollPos = scrollToDesktopHeroLandingSearchBar;
        } else if (browserWidth > tabletBreakpoint) {
            // tablet scroll position:
            showHideHeroScrollPos = scrollToTabletHeroLandingSearchBar;
        } else {
            // mobile scroll position:
            showHideHeroScrollPos = scrollToMobileHeroLandingSearchBar;
        }
    } else {
        if (browserWidth > desktopBreakpoint) {
            // desktop scroll position:
            showHideHeroScrollPos = scrollToDesktopHeroSearchBar;
        } else if (browserWidth > tabletBreakpoint) {
            // tablet scroll position:
            showHideHeroScrollPos = scrollToTabletHeroSearchBar;
        } else {
            // mobile scroll position:
            showHideHeroScrollPos = scrollToMobileHeroSearchBar;
        }
    }

    return isHeroSearchV2 ? showHideHeroScrollPos : 0;
};

//  when scrolling down the page, hide hero search & show header search
export const scrollSearchBarScrollingDown = ({
    heroSearchWrapper,
    isHeroSearchV2,
    searchWrapperRef
}) => {
    if (searchWrapperRef && searchWrapperRef.current) {
        isHeroSearchV2 &&
            searchWrapperRef.current.classList.add("scrolledDownSearch");
        isHeroSearchV2 &&
            searchWrapperRef.current.classList.remove("scrolledUpSearch");
    }

    if (heroSearchWrapper) {
        isHeroSearchV2 && (heroSearchWrapper.style.display = "none");
    }
};

// when scrolling up the page, show hero search & hide header search
export const scrollSearchBarScrollingUp = ({
    heroSearchWrapper,
    isHeroSearchV2,
    searchWrapperRef
}) => {
    if (searchWrapperRef && searchWrapperRef.current) {
        isHeroSearchV2 &&
            searchWrapperRef.current.classList.remove("scrolledDownSearch");
        isHeroSearchV2 &&
            searchWrapperRef.current.classList.add("scrolledUpSearch");
    }

    if (heroSearchWrapper) {
        isHeroSearchV2 && (heroSearchWrapper.style.display = "block");
    }
};

// for search input placeholder text:

export const placeholderText = ({ browserWidth, isPhotos = false }) => {
    let placeholder;

    const placeholderType = isPhotos
        ? heroSearchPlaceholderPhotos
        : heroSearchPlaceholderIcons;

    if (browserWidth > breakpoints.beforeDesktopPx) {
        // desktop hero search placeholder:
        placeholder = placeholderType.desktop;
    } else if (browserWidth > breakpoints.beforeTabletPx) {
        // tablet hero search placeholder:
        placeholder = placeholderType.tablet;
    } else {
        // mobile hero search placeholder:
        placeholder = placeholderType.mobile;
    }

    return placeholder;
};

/* Return the default value of the icons/photos selection in the search bar */
export const searchTypeForPath = () => {
    let searchType = "Icons";

    const photoPaths = [
        PHOTO_PATH,
        SEARCH,
        PHOTO_DETAIL,
        BROWSE_BY_TAG,
        BROWSE_BY_SHOOT_ID,
        BROWSE_BY_CREATOR_USERNAME,
        BROWSE_SIMILAR_BY_PHOTO_ID,
        BROWSE_BY_CAMPAIGN,
        photosLandingPath
    ];

    photoPaths.forEach(path => {
        if (useRouteMatch(path)) {
            searchType = "Photos";
        }
    });

    return searchType;
};

export const searchURLPath = ({ currentPath, searchType }) => {
    let path;

    if (searchType === "Photos") {
        // ^^ if selected toggle button === photos:
        path = SEARCH;
        // ^^ TODO: change this so PHOTO_PATH comes after /search/
    } else if (searchType === "Icons") {
        // ^^ if selected toggle button === icons:
        if (currentPath === iconsCollectionSearchPath) {
            // ^^ if the page user is on is collection page:
            path = iconsCollectionSearchPath;
        } else {
            path = iconsSearchPath;
        }
    } else {
        throw new Error(`Unknown search type "${searchType}"`);
    }

    return path;
};
